// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Bjv-","actions":"GroupTable_actions__1yRuv","deleteModalFooter":"GroupTable_deleteModalFooter__3Oj6p"};